import React, { Fragment } from 'react';
import autoBind from 'react-autobind';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

//Context
import { withGridContext } from './grid.factory';
import acValidation from '@common/validators/accessControl.validator';

class GridActionColumn extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  onActionClick(action, item) {
    return (e) => action.onClick && action.onClick(item);
  }

  defatulActions(action) {
    switch (action.type) {
      case 'edit':
        return {
          ...action,
          icon: 'far fa-edit',
          title: 'Editar',
        };
      case 'view':
        return {
          ...action,
          icon: 'far fa-eye',
          title: 'Visualizar',
        };
      case 'delete':
        return {
          ...action,
          icon: 'fas fa-times',
          title: 'Excluir',
        };
      case 'cancel':
        return {
          ...action,
          icon: 'far fa-ban',
          title: 'Cancelar',
        };
      case 'select':
        return {
          ...action,
          icon: 'fas fa-check',
          title: 'Selecionar',
        };
      case 'enable':
        return {
          ...action,
          icon: 'fas fa-check',
          title: 'Habilitar',
        };
      case 'disable':
        return {
          ...action,
          icon: 'fas fa-ban disable',
          title: 'Desabilitar',
        };
      case 'vincular':
        return {
          ...action,
          icon: 'fas fa-link',
          title: 'Vincular',
        };
      case 'disassociate':
        return {
          ...action,
          icon: 'fas fa-unlink',
          title: 'Desassociar',
        };
      case 'associate':
        return {
          ...action,
          icon: action.icon,
          title: 'Associar ' + action.name,
        };
      case 'copy':
        return {
          ...action,
          icon: 'far fa-copy',
          title: 'Copiar',
        };
      case 'guia':
        return {
          ...action,
          icon: 'fas fa-file-alt',
          title: 'Guias',
        };
      case 'movimento':
        return {
          ...action,
          icon: 'far fa-list-alt',
          title: 'Movimento da Parcela',
        };
      case 'baixas':
        return {
          ...action,
          icon: 'fas fa-chart-line',
          title: 'Baixas da Parcela',
        };
      case 'rastrear':
        return {
          ...action,
          icon: 'fas fa-shoe-prints',
          title: 'Rastrear',
        };

      case 'ativar':
        return {
          ...action,
          icon: 'fas fa-check',
          title: 'Ativar',
        };

      case 'desativar':
        return {
          ...action,
          icon: 'fas fa-ban disable',
          title: 'Desativar',
        };

      case 'custom':
        return {
          ...action,
          icon: action.icon,
          title: action.title,
        };
      default:
        return action;
    }
  }

  onMouseEnter(e) {
    const $target = $(e.target).parents('tr.hoverRow');
    const index = $target.data('index');
    $("[data-index='" + index + "']").addClass('hover');
  }

  onMouseLeave(e) {
    const $target = $(e.target).parents('tr.hoverRow');
    const index = $target.data('index');
    $("[data-index='" + index + "']").removeClass('hover');
  }

  filterShow(action, item) {
    var retorno = true;

    if (Array.isArray(action.url)) return action.url.some((x) => acValidation.checkPermissionByUrl(x));
    if (action.route) retorno = acValidation.checkPermissionsByName(action.route);
    if (action.url) retorno = acValidation.checkPermissionByUrl(action.url);
    if (action.isShow && retorno) retorno = action.isShow(item);

    return retorno;
  }

  checkDetailPermission(url) {
    if (Array.isArray(url)) return url.some((x) => acValidation.checkPermissionByUrl(x));
    if (url) return acValidation.checkPermissionByUrl(url);
    return true;
  }

  render() {
    let { actions, hash, data, detail, selectedRow, PlacementTooltip } = this.props.context;
    let { item, index } = this.props;
    actions = actions.map(this.defatulActions);
    const filterActions = actions.filter((act) => this.filterShow(act, item));
    return (
      <td
        style={{
          position: 'sticky',
          right: '0',
          zIndex: '99 !important',
          overflow: 'visible',
        }}
        className={`hoverRow action-strip`}
        data-index={`row-${hash}-${index}`}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <div className={filterActions.length > 3 ? 'filter-action-custom' : ''}>
          <ul className="container-btn-action">
            {filterActions.filter((x, i) => i <= 1).map((action, i) => this.renderAction(action, i, item))}
            {filterActions.length == 3 && this.renderAction(filterActions[2], 3, item)}
            {filterActions.length > 3 && (
              <li>
                <span className="d-inline-block">
                  <div className="btn-group dropleft">
                    <a>
                      <OverlayTrigger
                        key={`top-${index}`}
                        placement={PlacementTooltip || 'left-start'}
                        trigger="click"
                        rootClose={true}
                        overlay={
                          <div className={`dropdown-menu`}>
                            {filterActions
                              .filter((x, i) => i > 1)
                              .map((action, i) => this.renderMoreAction(action, i, item))}
                          </div>
                        }
                      >
                        <i className="fa fa-bars" tabIndex="0" data-toggle="tooltip" title="Mais Ações" />
                      </OverlayTrigger>
                    </a>
                  </div>
                </span>
              </li>
            )}
          </ul>
        </div>
      </td>
    );
  }

  shouldHideAction(action, item) {
    return action.hidden ?? (action.requiredField ? !item[action.requiredField] : false);
  }

  renderAction(action, index, item) {
    const hideAction = this.shouldHideAction(action, item);

    return (
      <li onClick={this.onActionClick(action, item)} key={index} hidden={hideAction}>
        <a>
          <i className={action.icon} tabIndex="0" data-toggle="tooltip" title={action.title} />
        </a>
      </li>
    );
  }

  renderMoreAction(action, index, item) {
    const hideAction = this.shouldHideAction(action, item);

    return (
      <div key={index} hidden={hideAction}>
        <Dropdown.Item onClick={this.onActionClick(action, item)}>{action.title}</Dropdown.Item>
      </div>
    );
  }
}

export default withGridContext(GridActionColumn);
